import React from "react";
import { Button, Typography } from "@mui/material";

interface CustomIconButtonProps {
  icon?: React.ReactNode; // Optional icon
  text: string;
  outline?: boolean;
  background?: string;
  variant?: "contained" | "outlined";
  padding?: string;
  color?: string;
  isDisabled?: boolean;
  size?: number;
  textColor?: string;
  height?: string | { xs?: string; sm?: string; md?: string };
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void; // Fixed type here
}

const CustomIconButton: React.FC<CustomIconButtonProps> = ({
  icon,
  text,
  size,
  outline = true,
  background = "",
  variant = "contained",
  padding,
  color,
  isDisabled = false,
  height,
  textColor,
  onClick,
}) => {
  const isTransparent = background === "transparent";
  const isError = background === "error";

  return (
    <Button
      variant={variant}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
      disabled={isDisabled}
      sx={(theme) => ({
        height: height || { xs: "28px", sm: "30px", md: "45px" },
        px: { xs: 1, sm: 2 },
        borderRadius: "8px",
        textTransform: "none",
        fontWeight: 700,
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        gap: icon ? { xs: 0.5, sm: 1 } : 0,
        backgroundColor: isTransparent ? "transparent" : isError ? theme.palette.error.main : theme.palette.primary.main,
        border: outline && !isDisabled ? `1px solid ${theme.palette.primary.main}` : "none",
        color: color == 'error' ? theme.palette.error.main : isTransparent ? `${theme.palette.primary.main}` : 'white',
        padding: padding || undefined,
        "&:hover": {
          backgroundColor: isTransparent ? "transparent" : isError ? theme.palette.error.dark : "#4039b3",
          boxShadow: "none",
        },
      })}
    >
      {icon && <>{icon}</>}
      <Typography
        color={textColor}
        variant={isTransparent ? "overline" : "body2"}
        fontWeight={700}
        fontSize={size}
      >
        {text}
      </Typography>
    </Button>
  );
};

export default CustomIconButton;
